/**
 * ResponsibleGamingOptionType.ts
 *
 * @see {@link ResponsibleGamingDialog}
 */
export class ResponsibleGamingOptionType {
    constructor(id, priority) {
        this.id = id;
        this.priority = priority;
        ResponsibleGamingOptionType.VALUES.push(this);
    }
    static getTypes() {
        return ResponsibleGamingOptionType.VALUES;
    }
    static getType(value) {
        return ResponsibleGamingOptionType[value];
    }
    compare(type) {
        let priority = this;
        if (type) {
            let value = this.priority - type.getPriority();
            priority = value > 0 ? this : type;
        }
        return priority;
    }
    getId() {
        return this.id;
    }
    getPriority() {
        return this.priority;
    }
    isExtraSpin() {
        return this == ResponsibleGamingOptionType.EXTRA_SPIN;
    }
    isSpinPrice() {
        return this == ResponsibleGamingOptionType.SPIN_PRICE;
    }
    isSingleGameStake() {
        return this == ResponsibleGamingOptionType.SINGLE_GAME_STAKE;
    }
    isMaximumLoss() {
        return this == ResponsibleGamingOptionType.MAXIMUM_LOSS;
    }
}
ResponsibleGamingOptionType.VALUES = [];
ResponsibleGamingOptionType.INACTIVE = -1;
ResponsibleGamingOptionType.SPIN_PRICE = new ResponsibleGamingOptionType("SPIN_PRICE", 0);
ResponsibleGamingOptionType.SINGLE_GAME_STAKE = new ResponsibleGamingOptionType("SINGLE_GAME_STAKE", 1);
ResponsibleGamingOptionType.MAXIMUM_LOSS = new ResponsibleGamingOptionType("MAXIMUM_LOSS", 2);
ResponsibleGamingOptionType.EXTRA_SPIN = new ResponsibleGamingOptionType("EXTRA_SPIN", 3);
//# sourceMappingURL=ResponsibleGamingOptionType.js.map